import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=3c24a586&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"
import style0 from "./Employee.vue?vue&type=style&index=0&id=3c24a586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c24a586",
  null
  
)

export default component.exports